import { render, staticRenderFns } from "./WishGrade.vue?vue&type=template&id=e9be2498&"
import script from "./WishGrade.ts?vue&type=script&lang=js&"
export * from "./WishGrade.ts?vue&type=script&lang=js&"
import style0 from "./WishGrade.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports